import { ReactElement } from "react";
import DisplayModal from "../DisplayModal";
import PostCard from "../post/PostCard";
import { Box } from "@mui/material";

interface Props {
  post: any | undefined;
  highlightWords: any[];
  onClose: () => void;
  addCommnetStatus: string[]
}

export default function PostCardModal({post, highlightWords, onClose, addCommnetStatus}: Props): ReactElement {
  const commentStatuses = ["Approved", ...addCommnetStatus]

  return (
    <DisplayModal
      open={Boolean(post)}
      sx={{ minWidth: "352px" }}
      onClose={onClose}
    >
      <Box sx={{ overflowY: "auto" , margin: "0 auto", width: 'min-content'}}>
        <PostCard
          post={post}
          // 参照用とするためタグ押下しても何もしない
          onClickTag={() => {}}
          highlightWords={highlightWords}
          commentStatuses={commentStatuses}
          readonly={true}
        />
      </Box>
    </DisplayModal>
  );
}
